import { skipToken } from '@reduxjs/toolkit/dist/query/react';
import { useGetProfileQuery, useSignInUserWithTokenQuery } from '../store/features/user/userSlice';
import { getTokenFromStorage } from '../utils/token';

export const useGetSignedInUser = () => {
  /**
   * Signing user in if we have token in local storage
   */
  const token = getTokenFromStorage();
  const { isSignedIn, userData, isSiginingIn, isError } = useSignInUserWithTokenQuery(token ?? skipToken, {
    selectFromResult: ({ isSuccess, data, isFetching, isError }) => ({
      isSignedIn: isSuccess,
      userData: data,
      isSiginingIn: isFetching,
      isError,
    }),
  });

  /**
   * Getting user profile if signed in
   */
  const { userState } = useGetProfileQuery(
    isSignedIn && userData
      ? {
          slug: userData.slug,
          userId: userData.id.toString(),
        }
      : skipToken,
    {
      selectFromResult: (result) => ({ userState: result }),
    }
  );
  return {
    ...userState,
    isFetching: token
      ? (isSiginingIn || userState.isFetching || userState.isUninitialized) && !isError && !userState.isError
      : false,
    isSignedIn: isSignedIn && Boolean(userState.data?.user) && userState.isSuccess,
    canSignIn: Boolean(token) && !isError && !userState.isError,
  };
};
